import React from "react";
import { Card, Button } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import DataTable from "examples/Tables/DataTable";
import MDInput from "components/MDInput";
import Swal from "sweetalert2";
import SessionsApi from "../../../Classes/API/Administration/SessionsApi";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { LanguageContext } from "App";
import CreateSessionReq from "../../../Classes/Models/Requests/Administration/CreateSessionReq";
import "./contract-search.scss";
import SearchStringOrIntReq2 from "Classes/Models/Requests/SearchStringOrIntReq";
import TextField from "@mui/material/TextField";

const ContractSessionsTable = ({ Contract, setIsLoaded }) => {
  const { translations } = useContext(LanguageContext);
  const TableColumns = [
    { Header: "Name", accessor: "Name", align: "left", width: "2330px" },
    {
      Header: "Egyptian Price",
      accessor: "EgyptianPrice",
      align: "center",
      width: "120px",
    },
    {
      Header: "Arab Price",
      accessor: "ArabPrice",
      align: "center",
      width: "120px",
    },
    {
      Header: "Other Price",
      accessor: "OtherPrice",
      align: "center",
      width: "120px",
    },
    { Header: "Update", accessor: "Update", align: "center", width: "120px" },
    {
      Header: "Reset to Parent",
      accessor: "ResetToParent",
      align: "center",
      width: "150px",
    },
    { Header: "Remove", accessor: "Remove", align: "center", width: "120px" },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);

  const DeleteSession = async (id) => {
    let SearchStringOrIntReq = new SearchStringOrIntReq2();
    SearchStringOrIntReq.SearchInt = id;
    var res = await SessionsApi.DeleteSession(SearchStringOrIntReq);

    if (res.status == "Success") {
      setIsLoaded(false);
      Swal.fire("Removed!", "The Session has been removed.", "success");
    } else {
      Swal.fire("Error!", "Something went wrong.", "error");
    }
  };

  const ResetSessionToParent = async (sessionId, sessionName) => {
    const result = await Swal.fire({
      title: "Reset Session Prices?",
      text: `Are you sure you want to reset "${sessionName}" prices to parent session values?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, reset it!",
    });

    if (result.isConfirmed) {
      try {
        const res = await SessionsApi.ResetSessionToParent(sessionId);

        if (res.status === "Success") {
          Swal.fire(
            "Reset!",
            "Session prices have been reset to parent session values.",
            "success"
          );
          setIsLoaded(false); // Refresh the data
        } else {
          Swal.fire("Error!", res.message || "Something went wrong.", "error");
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to reset session prices.", "error");
      }
    }
  };

  const ResetAllSessionsToParent = async () => {
    const result = await Swal.fire({
      title: "Reset All Session Prices?",
      text: `Are you sure you want to reset ALL session prices to their parent session values? This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, reset all!",
    });

    if (result.isConfirmed) {
      try {
        console.log(Contract.id);
        const res = await SessionsApi.ResetAllContractSessions(Contract.id);

        if (res.status === "Success") {
          Swal.fire(
            "Reset!",
            "All session prices have been reset to parent session values.",
            "success"
          );
          setIsLoaded(false); // Refresh the data
        } else {
          Swal.fire("Error!", res.message || "Something went wrong.", "error");
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to reset session prices.", "error");
      }
    }
  };

  const UpdateContractSession = async (Session) => {
    let updateSessionReq = new CreateSessionReq();

    updateSessionReq.ArabPrice = document.getElementById(
      `contractSession${Session.id}ArabPrice`
    ).value;
    updateSessionReq.EgyptianPrice = document.getElementById(
      `contractSession${Session.id}EgyptianPrice`
    ).value;
    updateSessionReq.OtherPrice = document.getElementById(
      `contractSession${Session.id}OtherPrice`
    ).value;

    updateSessionReq.Category = Session.category;
    updateSessionReq.Description = Session.description;
    updateSessionReq.Id = Session.id;
    updateSessionReq.SecretName = Session.secretName;
    updateSessionReq.Name = Session.name;
    updateSessionReq.IsAssessmentSession = Session.isAssessmentSession;
    updateSessionReq.IsHalfDuration = Session.isHalfDuration;
    updateSessionReq.IsContractSession = Session.isContractSession;

    var res = await SessionsApi.EditSession(updateSessionReq);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Session Updated Successfully",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        setIsLoaded(false);
      });
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  const inputStyle = {
    width: "90px",
    border: "1px solid #ccc",
    padding: "4px 8px",
    borderRadius: "8px",
    "& .MuiInputBase-input": {
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
      MozAppearance: "textfield",
    },
  };
  const handleWheel = (e) => e.target.blur();

  const MakeTableRow = (Session) => {
    return {
      Name: (
        <MDTypography
          className="input-data"
          variant="button"
          color="text"
          fontWeight="medium"
          sx={{ width: "10px" }}
        >
          {Session.name}
        </MDTypography>
      ),

      EgyptianPrice: (
        <TextField
          type="number"
          defaultValue={Session.egyptianPrice}
          inputProps={{
            id: `contractSession${Session.id}EgyptianPrice`,
          }}
          variant="standard"
          InputProps={{ disableUnderline: true }}
          sx={inputStyle}
          onWheel={handleWheel}
        />
      ),

      ArabPrice: (
        <TextField
          type="number"
          defaultValue={Session.arabPrice}
          inputProps={{
            id: `contractSession${Session.id}ArabPrice`,
          }}
          variant="standard"
          InputProps={{ disableUnderline: true }}
          sx={inputStyle}
          onWheel={handleWheel}
        />
      ),

      OtherPrice: (
        <TextField
          type="number"
          defaultValue={Session.otherPrice}
          inputProps={{
            id: `contractSession${Session.id}OtherPrice`,
          }}
          variant="standard"
          InputProps={{ disableUnderline: true }}
          sx={inputStyle}
          onWheel={handleWheel}
        />
      ),

      Update: (
        <button
          className="btn btn-outline-success"
          onClick={() => UpdateContractSession(Session)}
        >
          Update
        </button>
      ),

      // New reset button for each row
      ResetToParent: (
        <button
          className="btn btn-outline-info"
          onClick={() => ResetSessionToParent(Session.id, Session.name)}
          title="Reset prices to parent session values"
        >
          Reset
        </button>
      ),

      Remove: (
        <button
          className="btn btn-outline-warning"
          onClick={() => DeleteSession(Session.id)}
        >
          Remove
        </button>
      ),
    };
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((Patient, index) => {
      rows.push(MakeTableRow(Patient, index));
    });
    setTableDataRows(rows);
  };

  useEffect(() => {
    if (
      Contract.getContractSessions &&
      Contract.getContractSessions.length > 0
    ) {
      RefreshTable(Contract.getContractSessions);
    } else {
      setTableDataRows([]);
    }
  }, [Contract]);

  return (
    <Card className="mt-5">
      <MDBox
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        coloredShadow="info"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ borderTopLeftRadius: "1.1rem", borderTopRightRadius: "1.1rem" }}
      >
        <MDTypography variant="h6" color="white">
          Contract Sessions Prices
        </MDTypography>

        {/* Global Reset Button */}
        <Button
          variant="contained"
          color="warning"
          onClick={ResetAllSessionsToParent}
          disabled={
            !Contract.getContractSessions ||
            Contract.getContractSessions.length === 0
          }
          sx={{
            color: "#ffff",
            backgroundColor: "#ff9800",
            "&:hover": {
              backgroundColor: "#f57c00",
            },
            "&:disabled": {
              backgroundColor: "rgba(255, 152, 0, 0.5)",
            },
          }}
        >
          Reset All to Parent Prices
        </Button>
      </MDBox>

      <MDBox pt={3}>
        {TableDataRows.length > 0 ? (
          <DataTable
            sx={{ width: TableColumns.width }}
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        ) : (
          <MDBox p={3} textAlign="center">
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="medium"
            >
              No Sessions
            </MDTypography>
          </MDBox>
        )}
      </MDBox>
    </Card>
  );
};

export default ContractSessionsTable;
